import { useEffect } from 'react';
import { Provider } from 'react-redux';
import { BrowserRouter, useNavigate } from 'react-router';
import { setNavigate } from 'shared/utils/navigationService';
import { envActions } from '@buy-viasat/redux/src/env';
import { scheduleInstallationActions } from '@buy-viasat/redux/src/schedule-installation';

import { PersistGate } from 'redux-persist/integration/react';
import { ViasatTheme } from 'shared/assets/styles/theme';
import { Navigator } from 'shared/Navigator';
import ThemeContext from 'shared/providers/hooks/ThemeContext';
import { persistor, store } from 'shared/store';

import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';

import '@vst/beam/index.scss';

const queryClient = new QueryClient();

// Must live inside BrowserRouter — useNavigate() requires the router context.
function NavigatorSetter(): null {
  const nav = useNavigate();
  useEffect(() => {
    setNavigate(nav);
  }, [nav]);
  return null;
}

const App = (): JSX.Element => {
  useEffect((): void => {
    // set env -- only enter necessary items here.  PLEASE AVOID ACCESS KEYS
    store.dispatch(envActions.setEnv({ aemUrl: process.env['REACT_APP_AEM_URL'] }));
    // Collect date
    store.dispatch(scheduleInstallationActions.setToday(new Date()));
  }, []);

  return (
    <QueryClientProvider client={queryClient}>
      <ReactQueryDevtools />
      <Provider store={store}>
        <PersistGate loading={null} persistor={persistor}>
          <BrowserRouter>
            <ThemeContext.Provider value={ViasatTheme}>
              <NavigatorSetter />
              <Navigator />
            </ThemeContext.Provider>
          </BrowserRouter>
        </PersistGate>
      </Provider>
    </QueryClientProvider>
  );
};

export default App;
